export default "__VITE_ASSET__CvaIkag1__"